enum RadioIconTypes {
  ICON = 'icon',
  SWATCHCOLOR = 'swatchcolor',
  IMAGE = 'image',
  VALUE = 'value',
}
enum RadioButtonAlignment {
  TOP = 'top',
  CENTER = 'center',
}

export { RadioIconTypes, RadioButtonAlignment };
